var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"economic-dynamics"},[_vm._m(0),_c('div',{staticClass:"chart-container"},[_c('Echart',{attrs:{"options":_vm.chartOptions,"id":"EconomicDynamicsChart","height":"100%","width":"100%"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('span',{staticClass:"title-text"},[_vm._v("企业经济动态(2022~2025)")])])
}]

export { render, staticRenderFns }